import React, { useState, useCallback } from 'react'
import { Link } from 'react-router-dom'
import useStore from '../../store'
// import BlurText from '../blurText'
import Layout from '../layout'
import './Intro.css'

const Intro = ({ name, to, title, image, imageHover }) => {
  const playByName = useStore((state) => state.playByName)
  const [hovered, setHovered] = useState(false)
  const src = hovered ? imageHover : image

  const onMouseEnter = useCallback(() => {
    setHovered(true)
    // playByName(name, 'hover')
  }, [])

  const onClick = useCallback(() => {
    playByName(name, 'click')
    setHovered(false)
  }, [playByName, name])

  return (
    <Layout>
      <div className="g-intro">
        <Link
          to={to} 
          onMouseEnter={onMouseEnter}
          onMouseLeave={() => setHovered(false)}
          onClick={onClick}
        >
          <img alt={title} src={src} />
          {/* {texts.map((text, i) => (
            <BlurText key={i} hovered={hovered}>
              {text}
            </BlurText>
          ))} */}
        </Link>
      </div>
    </Layout>
  )
}

export default Intro
